import './AxisTickWithTruncation.css';
export var directionValue = 'var(--_z2zz8y0-3-12-1)';
export var tickStyle = '_z2zz8y2-3-12-1';
export var widthContainer = 'var(--_z2zz8y1-3-12-1)';